var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 124.157,
    height: 68,
    viewBox: "0 0 124.157 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3",
    "data-name": "Ret\\xE2ngulo 3",
    width: 32.844,
    height: 54.668,
    fill: "#f591a8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9",
    "data-name": "Grupo 9",
    transform: "translate(-288.334 -386.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5",
    "data-name": "Grupo 5",
    transform: "translate(277.492 392.663)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "CPG",
    transform: "translate(48 42.559)",
    fill: "#1a1a1a",
    fontSize: 40,
    fontFamily: "NotoSans-Bold, Noto Sans",
    fontWeight: 700,
    letterSpacing: "0.09em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CPG")), /*#__PURE__*/React.createElement("text", {
    id: "EMPRESAS",
    transform: "translate(63 58.559)",
    fill: "#1a1a1a",
    fontSize: 10,
    fontFamily: "NotoSans-Bold, Noto Sans",
    fontWeight: 700,
    letterSpacing: "0.09em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "EMPRESAS"))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3",
    transform: "translate(288.334 386.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M10.6,52.63l.008.014-.884-.472c-2.711-1.441-7.5-4.787-9.157-10.945a18.615,18.615,0,0,1,.057-9.281C1.779,27.2,4.117,24.471,6.6,21.6a27.042,27.042,0,0,0,5.736-8.984A24.132,24.132,0,0,0,13.382,1.055L13.233,0l.636.79A24.444,24.444,0,0,1,17.914,8.2a25.91,25.91,0,0,1,1.266,9.7A24,24,0,0,1,16.3,28.476a19.308,19.308,0,0,1-2.245,3.191,30.939,30.939,0,0,0-3.384,4.89c-1.93,3.376-2.2,4.792-2.3,5.324-.057.3-.107.6-.143.891a14.5,14.5,0,0,0,.591,5.93,15.029,15.029,0,0,0,1.267,3.019l.225.381Z",
    transform: "translate(0)",
    fill: "#fd1c50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    "data-name": "Caminho 2",
    d: "M49.256,65.937a14,14,0,0,1-4.418,8.255,14.483,14.483,0,0,1-4.266,3.151,13.934,13.934,0,0,1-6.947,1.341c-.341-.028-.671-.063-.972-.114a11.943,11.943,0,0,1-1.8-.306,13.067,13.067,0,0,1-3.743-1.57,7.169,7.169,0,0,0,4.142.683,3.836,3.836,0,0,0,1.6-.52,4.9,4.9,0,0,0,1.894-3.217,6.368,6.368,0,0,0-1.867-5.15q-1.558.695-3.127,1.392Q30.96,64.5,32.19,59.1q5.044,2.395,10.088,4.8c-.45.265-.906.532-1.363.791-.272.16-.539.319-.811.478a10.138,10.138,0,0,1-.887,12.551,11.652,11.652,0,0,0,3-3.117,11.275,11.275,0,0,0,1.743-8.334,14.329,14.329,0,0,0-2.47-4.912c-1.034-1.463-1.8-2.4-1.8-2.4a14.663,14.663,0,0,1-3.737-12.922,13.726,13.726,0,0,1,2.615-5.562l.7-.918-.09,1.151a15.644,15.644,0,0,0,1.346,8.233A18.061,18.061,0,0,0,44.3,53.892a15.236,15.236,0,0,1,4.353,6.522,13.477,13.477,0,0,1,.6,5.523",
    transform: "translate(-16.483 -24.049)",
    fill: "#fd1c50"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.00dc609423bbad38a9e985d41b9ff664.svg";
export { ForwardRef as ReactComponent };